import { EntityHistory } from "../../entity/EntityHistory";

export class DtoHistorysDeleteRes extends EntityHistory {
  public message: string | null = null;
}
